import {AuthorizationManager} from "@eryxcoop/appyx-comm";

export default class BearerAuthorizationManager extends AuthorizationManager {
    ACCESS_TOKEN = 'sapore-access-token';

    constructor(session) {
        super();
        this._session = session
    }

    session() {
        return this._session
    }

    configureHeaders(headers) {
        headers['Authorization'] = `Bearer ${this._getAccessToken()}`
    }

    _getAccessToken() {
        return this._session.getToken()
    }
}
